<script>
import WorkflowsListing from '@/components/workflows/WorkflowsListing';
import WorkflowEditorCanvas from '@/components/workflows/WorkflowEditorCanvas';
import WorkflowEditor from '@/components/workflows/WorkflowEditor';
import WorkflowLog from '@/components/workflows/WorkflowLog';
import NotificationsCenter from "@/components/common/NotificationsCenter";
import JsonEditor from "@/components/common/JsonEditor";
import Reminders from "@/components/misc/Reminders";

export default {
  name: 'App',
  template: '#app-template',
  components: {
    WorkflowsListing,
    WorkflowLog,
    WorkflowEditor,
    WorkflowEditorCanvas,
    NotificationsCenter,
    Reminders,
    JsonEditor
  },
};
</script>

<style lang="scss">
@import "styles/core";
</style>
